import { ReactElement } from 'react'

export function RadioSelected(props: { className?: string }): ReactElement {
  const maskId = `mask_${Math.random()}`
  const url = `url(#${maskId})`

  return (
    <svg
      className={props.className}
      width="20"
      height="21"
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask id={maskId} style={{ maskType: 'alpha' }} maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="21">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10 0.733398C4.48 0.733398 0 5.2134 0 10.7334C0 16.2534 4.48 20.7334 10 20.7334C15.52 20.7334 20 16.2534 20 10.7334C20 5.2134 15.52 0.733398 10 0.733398ZM10 18.7334C5.58 18.7334 2 15.1534 2 10.7334C2 6.3134 5.58 2.7334 10 2.7334C14.42 2.7334 18 6.3134 18 10.7334C18 15.1534 14.42 18.7334 10 18.7334ZM15 10.7334C15 13.4948 12.7614 15.7334 10 15.7334C7.23858 15.7334 5 13.4948 5 10.7334C5 7.97197 7.23858 5.7334 10 5.7334C12.7614 5.7334 15 7.97197 15 10.7334Z"
          fill="white"
        />
      </mask>
      <g mask={url}>
        <rect x="-2" y="-1.2666" width="24" height="24" fill="currentColor" />
      </g>
    </svg>
  )
}
